import React from "react";
import { ChevronDown16Regular, ChevronRight16Regular } from "@fluentui/react-icons";
import { IRepertoireField } from "../../../repertoire/types/IRepertoireField";
import { IInstrumentation } from "../../../repertoire/types/IInstrumentation";
import { IArtist } from "../../../repertoire/types/IArtist";
import { IContributorItem } from "../../../repertoire/types/IContributorItem";
import { ITitle } from "../../../repertoire/types/ITitle";
import DisplayTableDataCells from "./DisplayTableDataCells";
import { IProductWorkDataItems } from "../../../repertoire/types/IProductWorkDataItems";
import { ILookupOptionsAndOnChangeFunctions, IRowActions } from "./DisplayTable";
import { IUnpaidClaimsSearchResult } from "../../types/IUnpaidClaimsSearchResult";
import { DEPENDENT_ROW_ACTION } from "../../Consts";
import { isTableAction } from "../../types/ITableAction";
import { IAgreementWorkDataItems } from "../../../repertoire/types/IAgreementWorkDataItems";
import { IMyPackagesResult } from "../../../repertoire/types/IMyPackagesResult";

export interface IDisplayTableRowProps {
    tableContentItem: IInstrumentation | IArtist | IContributorItem | ITitle | IUnpaidClaimsSearchResult;
    index: number;
    tableData: IRepertoireField[];
    showRowNumber?: boolean;
    isExpandable?: boolean;
    rowActions?: IRowActions;
    removeRowAction?: (item: IProductWorkDataItems | IInstrumentation | IArtist | IContributorItem | ITitle | IUnpaidClaimsSearchResult | IAgreementWorkDataItems) => void;
    lookupOptionsAndOnChangeFunctions?: ILookupOptionsAndOnChangeFunctions;
    isSearchResultTable?: boolean;
    isRenderLinkTitle?: boolean;
    getAgreementDetails?: (dataSource: string, agreementID) => void;
    addToPackages?: (userName: string, entityType: string, entityIds: number[]) => IMyPackagesResult;
    searchResultsTableData: IRepertoireField[];
    addCopiedProductWorks: (order: number) => void;
    isDependentRow?: boolean;
    displayRowNumber?: number | null;
    packageActionsDisabled?: boolean;
}
const DisplayTableRow: React.FC<IDisplayTableRowProps> = ({
    tableContentItem,
    index,
    tableData,
    showRowNumber,
    isExpandable,
    rowActions,
    removeRowAction,
    lookupOptionsAndOnChangeFunctions,
    isSearchResultTable,
    isRenderLinkTitle,
    getAgreementDetails,
    addToPackages,
    searchResultsTableData,
    addCopiedProductWorks,
    isDependentRow,
    displayRowNumber,
    packageActionsDisabled
}) => {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const onExpandClicked = () => {
        setIsExpanded(!isExpanded);
    }
    const tableDataCells: JSX.Element[] = []; 
    if (isExpandable) {
        const ExpandIcon = isExpanded ? ChevronDown16Regular : ChevronRight16Regular;
        tableDataCells.push(
            <td className="td">
                <ExpandIcon
                    title="Expand row"
                    className="icon"
                    onClick={onExpandClicked}
                />
            </td>
        );
    }
    const isIconButtonThatNeedsToRenderAsALink = (cellData) => {
        return isTableAction(cellData.fieldType) && cellData.fieldType === DEPENDENT_ROW_ACTION && rowActions && rowActions.iconButton && rowActions.iconButton.onClick && rowActions.iconButton.renderTitleAsLink === true;
    }
    const isRenderLink = isRenderLinkTitle || tableData.filter(item => isIconButtonThatNeedsToRenderAsALink(item))?.length === 1;
    if (showRowNumber) {
        tableDataCells.splice(0, 0, <td key={`${index} RowNumber`} title="Row Number"><div className={"tableCell"}>{displayRowNumber ?? ""}</div></td>);
    }
    tableData
        .map((field) => {
            tableDataCells.push(
                <DisplayTableDataCells
                    tableData={tableData}
                    cellData={field}
                    tableContentItem={tableContentItem}
                    isExpanded={isExpanded}
                    rowActions={rowActions}
                    removeRowAction={removeRowAction}
                    lookupOptionsAndOnChangeFunctions={lookupOptionsAndOnChangeFunctions}
                    rowIndex={index}
                    isSearchResultTable={isSearchResultTable}
                    isLinkTitle={isRenderLink}
                    getAgreementDetails={getAgreementDetails}
                    addToPackages={addToPackages}
                    searchResultsTableData={searchResultsTableData}
                    addCopiedProductWorks={addCopiedProductWorks}
                    isDependentRow={isDependentRow}
                    packageActionsDisabled={packageActionsDisabled}
                />
            );
        });
    return (
        <tr key={`row ${index}`} className={`tr tableRow ${isDependentRow ? "dependent" : ""}`}>
            {tableDataCells}
        </tr>
    );
}

export default DisplayTableRow;